import {Component, OnDestroy, OnInit} from '@angular/core';
import {ListItemsComponent} from '@abstract/list-items/list-items.component';
import {EquipmentPagesService} from '../services/equipment-pages/equipment-pages.service';
import {EventsService} from '@services/events.service';
import {EquipmentCardEnums} from '@namespaces/equipment.namespace';
import {UserNamespace} from '@namespaces/user.namespace';
import {CardApiService} from '@modules/equipment-card/services/card.api.service';

@Component({
    selector: 'app-apparatus-list',
    templateUrl: './apparatus-list.component.html',
})
export class ApparatusListComponent extends ListItemsComponent<EquipmentPagesService> implements OnInit, OnDestroy {
    constructor(
        service: EquipmentPagesService,
        private cardApi: CardApiService,
        private events: EventsService,
    ) {
        super(service);
    }

    public permissions = UserNamespace.Permission;
    public statuses = EquipmentCardEnums.EquipmentStatus;

    ngOnInit() {
        super.ngOnInit();
    }

    removeItems() {
        this.events.showConfirm({
            title: 'Вы уверены, что хотите удалить выбранное оборудование?',
            confirmButtonTitle: 'Удалить',
        }).subscribe(() => {
            this.service.deleteMultiple({
                queryParams: {
                    id: this.selectedValues$.getValue()
                }
            }).toPromise().then(() => {
                this.service.updateItems();
                this.clearAllValues();
            }, error => {
                this.service.updateItems();
                this.clearAllValues();
            });
        }, () => {});
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
